import {Button, Card, Flex, Tag, theme, Typography} from 'antd';
import React from 'react';

interface IProps {
  item: any;
  toggleView?: any;
  handleItem?: any;
}

const GMGiftCard: React.FC<IProps> = (props) => {
  const {item, toggleView, handleItem} = props;
  const {token}: any = theme.useToken();
  const toggleAndHandle = () => {
    toggleView();
    handleItem(item);
  };
  const isPhysical = item?.redemptionDetails[0].method === 'PHYSICAL';

  return (
    <Card
      hoverable
      onClick={toggleAndHandle}
      style={{flex: '0 0 23%'}}
      styles={{
        body: {display: 'flex', flexDirection: 'column', gap: 10, width: '100%', padding: 16},
      }}
      cover={
        <img
          src={item.images[1].imageUrl}
          alt={item.images[1].altText}
          style={{height: 140, objectFit: 'cover'}}
        />
      }>
      <div>
        <Tag color={isPhysical ? 'default' : 'blue'}>{isPhysical ? 'Plastic' : 'eGift'}</Tag>
      </div>
      <Flex vertical gap={2} style={{flex: 1}}>
        <Typography.Text strong style={{fontSize: 13}}>
          {item.titleShort}
        </Typography.Text>
        {item?.description && (
          <Typography.Text style={{fontSize: 12, color: token.colorTextSecondary}} ellipsis>
            {item.description}
          </Typography.Text>
        )}
      </Flex>
      <Button type="primary" size="small" block onClick={toggleAndHandle}>
        Redeem
      </Button>
    </Card>
  );
};

export default GMGiftCard;
